module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-qoro-corian-blade.7636263d.jpg";